// extracted by mini-css-extract-plugin
export default {"content":"ACConsumption_content__UwDnG","headerContainer":"ACConsumption_headerContainer__Epjq9","headerIcon":"ACConsumption_headerIcon__OIc6P","cell":"ACConsumption_cell__BVGAk"};